export const getValueOrUndefined = (
  isValid: boolean,
  value?: number | string,
  // eslint-disable-next-line no-undefined
) => (isValid ? value : undefined)
